import { UiDepartment, UiFunction } from './../../../../models/data/UI-data.model ';
import { createAction, props } from '@ngrx/store';
import { DefaultModuleDetail, GetStaticBody } from 'src/app/models/data/user.model';

export const loadHomePages = createAction(
  '[HomePage] Load HomePages'
);

export const fetchUiDepartment = createAction(
  '[HomePage] Fetch UI Department'
)

export const setUiDepartment = createAction(
  '[HomePage] Set UI Department',
  props<{
    uiDepartment: UiDepartment[]
  }>()
)

export const clearUiDepartment = createAction(
  '[HomePage] Clear UI Department',
)

export const clearUIHomePage = createAction(
  '[HomePage] Clear UI Home Page'
)

export const toggleFunctionPreference = createAction(
  '[HomePage] Toggle Function Preference',
  props<{
    functionCode: number
  }>()
)

export const upsertUiFunction = createAction(
  '[HomePage] Upsert UI Function',
  props<{
    UiFunction: UiFunction
  }>()
)

export const setSelectedDepartment = createAction(
  '[HomePage] Set Selected Department',
  props<{
    selectedDepartment: number
  }>()
)

export const clearSelectedDepartment = createAction(
  '[HomePage] Clear Selected Department',
)

export const setSelectedFunction = createAction(
  '[HomePage] Set Selected Function',
  props<{
    selectedFunction: string
  }>()
)

export const clearSelectedFunction = createAction(
  '[HomePage] Clear Selected Function',
)

export const fetchStaticData = createAction(
  '[HomePage] Fetch Static Data'
)

export const setStaticData = createAction(
  '[HomePage] Set Staic Data',
  props<{
    staticData: GetStaticBody
  }>()
)

export const clearStaticData = createAction(
  '[HomePage] Clear Staic Data'
)

export const setStaticDataDefaultModules = createAction(
  '[HomePage] Set Staic Data Default Modules',
  props<{
    defaultModules: DefaultModuleDetail[]
  }>())
